import React from "react";

const AboutPage = () => {
  return (
    <section className="lg:py-16 py-6 lg:px-40 px-4 bg-gray-100">
      <div className="container mx-auto text-center">
        <h2 className="text-4xl font-bold mb-4">About Pawan Kaaz</h2>
        <p className="text-lg mb-6">
          Pawan Kaaz stands as a beacon of excellence in the denim industry, in
          TANK ROAD renowned for our exceptional 'Kaaj Button' services, expert
          stitching, and flawless finishing. Our commitment to quality and
          innovation has made us the preferred choice for jeans manufacturers
          for over 15 years. With separate, state-of-the-art factories for each
          production stage, we ensure seamless operations and superior results.
          We were the first to implement CCTV in all our factories, ensuring
          accuracy and transparency. As a digitally-driven company, we provide
          GST billing and maintain comprehensive records, offering a paperless
          experience for our valued clients.
        </p>
        <button className="bg-black text-white px-4 py-2 rounded mb-6">
          Learn More About Us
        </button>
        <div className="relative w-full max-w-lg mx-auto">
          <img
            src="https://imgs.search.brave.com/1z9909aaNR0IUD-1m2jV1HN0JF3KO0jUHYqvsTl-9mo/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5pc3RvY2twaG90/by5jb20vaWQvNjY3/MDc0Nzg2L3Bob3Rv/L2plYW5zLXNoZWxm/LmpwZz9zPTYxMng2/MTImdz0wJms9MjAm/Yz15WEZINndUcmkx/X2NmVmlyU040QXVm/SkZkWXpDbm5laEI1/QU5SQUhncWV3PQ"
            alt="Hero"
            className="w-full h-auto rounded shadow-md"
          />
        </div>
      </div>
    </section>
  );
};

export default AboutPage;
